import { Link } from 'react-router-dom';
import Home_Hub from '../../assets/goods/new-arrivals/home-hub.webp';
import Grade_Tools from '../../assets/goods/new-arrivals/grade-tools.webp';
import Kitchen_Collection from '../../assets/goods/new-arrivals/kitchen-collection.webp';
import Air_Purifier from '../../assets/goods/new-arrivals/air-purifier.webp';

export default function NewArrivals() {
  return (
    <section className="my-12">
      <h2 className="text-xl md:text-2xl font-bold mb-6 flex items-center text-gray-800">
        <span className="w-1 h-6 bg-[#ff9906] mr-2 inline-block"></span>
        New Arrival
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Smart Home Hub */}
        <div className="relative h-[400px] bg-white rounded-lg overflow-hidden shadow-lg border">
          <img
            src={Home_Hub}
            alt="Smart Home Hub"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 flex flex-col justify-end p-6 bg-gradient-to-t from-gray-900/80 to-transparent">
            <h3 className="text-2xl font-bold mb-2 text-white">Smart Home Hub</h3>
            <p className="mb-4 text-sm text-gray-100">
              Control all your smart appliances from one central device.
            </p>
            <Link
              href="/products/smart-home-hub"
              className="text-sm font-medium text-white hover:text-[#ff9906]"
            >
              Shop Now
            </Link>
          </div>
        </div>


        {/* Right column grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Kitchen Collection */}
          <div className="relative h-[190px] bg-white rounded-lg overflow-hidden shadow-md col-span-2">
            <img
              src={Kitchen_Collection}
              alt="Kitchen Collection" fill className="object-cover"
            />
            <div className="absolute inset-0 flex flex-col justify-end p-4 bg-gradient-to-t from-gray-900/70 to-transparent">
              <h3 className="text-xl font-bold mb-1 text-white">Kitchen Collection</h3>
              <p className="mb-2 text-xs text-gray-100">Premium appliances for the modern kitchen.</p>
              <Link href="/category/kitchen-appliances" className="text-xs font-medium text-white hover:text-[#ff9906]">
                Shop Now
              </Link>
            </div>
          </div>

          {/* Air Purifiers */}
          <div className="relative h-[190px] bg-white rounded-lg overflow-hidden shadow-md">
            <img
              src={Air_Purifier}
              alt="Air Purifier" fill className="object-cover"
            />
            <div className="absolute inset-0 flex flex-col justify-end p-4 bg-gradient-to-t from-gray-900/70 to-transparent">
              <h3 className="text-lg font-bold mb-1 text-white">Air Purifiers</h3>
              <p className="mb-2 text-xs text-gray-100">Breathe cleaner air</p>
              <Link href="/category/air-purifiers" className="text-xs font-medium text-white hover:text-[#ff9906]">
                Shop Now
              </Link>
            </div>
          </div>

          {/* Power Tools */}
          <div className="relative h-[190px] bg-white rounded-lg overflow-hidden shadow-md">
            <img
              src={Grade_Tools}
              alt="Power Tools" fill className="object-cover"
            />
            <div className="absolute inset-0 flex flex-col justify-end p-4 bg-gradient-to-t from-gray-900/70 to-transparent">
              <h3 className="text-lg font-bold mb-1 text-white">Power Tools</h3>
              <p className="mb-2 text-xs text-gray-100">Professional grade tools</p>
              <Link href="/category/power-tools" className="text-xs font-medium text-white hover:text-[#ff9906]">
                Shop Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
